import { useTranslation } from 'react-i18next';
import { z } from 'zod';

export const useUploadDialogValidationSchema = () => {
  const { t } = useTranslation(['validation']);

  return z.object({
    files: z.array(z.instanceof(File, { message: t('validation:incorrectFileType') })),
  });
};
